<template>
  <div class="event-full-nav-anchors" @mouseleave="activeIndex = null">
    <internal-nav-anchors-item
      v-for="(item, index) in anchors"
      :key="index"
      :item="item"
      :size="sizes[index]"
      :is-active="activeIndex === index"
      :is-current="currentIndex === index"
      @mouseenter.native="activeIndex = index"
      @click.native="
        $emit('toggleActive', false)
        activeIndex = null
      "
    ></internal-nav-anchors-item>
  </div>
</template>

<script>
import InternalNavAnchorsItem from '@/components/nav/InternalNavAnchorsItem'

export default {
  components: {
    InternalNavAnchorsItem
  },
  props: {
    anchors: Array,
    currentIndex: Number
  },
  data() {
    return {
      items: [],
      activeIndex: null
    }
  },
  computed: {
    step() {
      return parseInt(70 / (this.anchors.length - 1))
    },
    sizes() {
      return Array(this.anchors.length)
        .fill()
        .map((item, index) => {
          if (this.activeIndex !== null) {
            const indexDelta = Math.abs(index - this.activeIndex)

            return 90 - indexDelta * this.step
          } else {
            return 20
          }
        })
    }
  }
}
</script>

<style lang="scss">
.event-full-nav-anchors {
  width: 65px;
  padding: 15px 0;
  border-bottom: solid 1px rgba(#fff, 0.1);
}
</style>
